import React from "react";

import { Box } from "@mui/material";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";

import RoundChip from "design-system/components/RoundChip";
import { rideStatusLabelColors, grayMedium, black } from "design-system/colors";
import { Trip } from "types";

const DEFAULT_STATUS_COLORS = {
  backgroundColor: grayMedium,
  color: black,
};

function DriverStatusColumn(props: GridRenderCellParams<Trip>) {
  const { row } = props;

  const dispatchStatus = row.routes?.[0]?.dispatchStatus;

  if (!dispatchStatus) {
    return null;
  }

  const colorScheme =
    rideStatusLabelColors[dispatchStatus.toLowerCase()] || DEFAULT_STATUS_COLORS;

  return (
    <Box display="flex" justifyContent="center">
      <RoundChip
        backgroundColor={colorScheme.backgroundColor}
        color={colorScheme.color}
        label={dispatchStatus.toUpperCase().replace(/-/g, " ")}
      />
    </Box>
  );
}

export default DriverStatusColumn;
